import { defineStore } from 'pinia';
import { ref } from 'vue';

import type { BreadcrumbProps } from '@/dsComponents/breadcrumbs/types';

export const useBreadcrumbsStore = defineStore('breadcrumbs', () => {
	const breadcrumbs = ref<BreadcrumbProps>({ items: [] });

	const setBreadcrumbs = (payload: BreadcrumbProps) => {
		breadcrumbs.value = payload;
	};

	return {
		breadcrumbs,
		setBreadcrumbs,
	};
});
